import type { ISourceOptions } from "@tsparticles/engine";

// "Mission Deck" starfield — amber/cyan twinkle with faint violet accents,
// rendered as a screen-blended overlay drifting OVER the six painterly
// backgrounds (see ParticlesContainer in App.tsx). Kept sparse and small so
// it reads as fine sparkle/dust over the art rather than a busy layer on
// top of already-detailed paintings; background stays near-black so it is a
// no-op under mix-blend-mode: screen (screen against black = transparent).
export const particlesConfig: ISourceOptions = {
  background: {
    color: "#05070d",
    position: "50% 50%",
    repeat: "no-repeat",
    size: "cover"
  },
  fpsLimit: 60,
  particles: {
    number: {
      value: 28,
      density: {
        enable: true
      }
    },
    color: {
      value: ["#eef2f7", "#8fd8ff", "#f2a93b", "#a78bfa"]
    },
    shape: {
      type: "circle"
    },
    opacity: {
      value: { min: 0.4, max: 1 },
      animation: {
        enable: true,
        speed: 1,
        sync: false,
        startValue: "random"
      }
    },
    size: {
      value: { min: 1, max: 3 },
      animation: {
        enable: true,
        speed: 1,
        sync: false,
        startValue: "random"
      }
    },
    move: {
      enable: true,
      speed: 0.8,
      direction: "none",
      random: true,
      straight: false,
      outModes: "bounce",
      attract: {
        enable: true,
        rotate: { x: 600, y: 1200 }
      }
    },
    groups: {
      tooltip: {
        size: { value: { min: 3, max: 5 } },
        color: { value: "#f2a93b" },
        twinkle: {
          particles: {
            enable: true,
            color: "#f2a93b",
            frequency: 0.4,
            opacity: 1
          }
        },
        number: { value: 3 }
      },
      regular: {
        size: { value: { min: 1, max: 2.5 } },
        color: { value: ["#eef2f7", "#8fd8ff", "#a78bfa"] },
        twinkle: {
          particles: {
            enable: true,
            color: "#8fd8ff",
            frequency: 0.08,
            opacity: 0.7
          }
        },
        number: { value: 70 }
      }
    },
    twinkle: {
      particles: {
        enable: true,
        color: "#8fd8ff",
        frequency: 0.1,
        opacity: 0.8
      },
      lines: {
        enable: false,
        frequency: 0.2,
        opacity: 0.4
      }
    }
  },
  interactivity: {
    detectsOn: "window",
    events: {
      onHover: {
        enable: true,
        mode: "repulse"
      },
      resize: {
        enable: true
      }
    },
    modes: {
      repulse: {
        distance: 150,
        duration: 0.4
      }
    }
  },
  detectRetina: true,
};
